<template>
  <main class="panel" :class="{ rounded: $breakpoint.mdAndUp && rounded, transparent }">
    <div
      v-if="$slots.header || title"
      class="py-3"
      :class="{ 'border-b border-gray-lighter container-padding': !transparent, 'pl-2': transparent }"
    >
      <slot name="header">
        <div
          :class="{
            rounded: $breakpoint.mdAndUp && rounded,
            'flex items-center justify-between': $slots.headerAlign
          }"
        >
          <h1 class="text-xl font-medium mb-0">{{ title }}</h1>

          <slot name="headerAlign" />
        </div>
      </slot>
    </div>

    <div class="panel-body h-full w-full">
      <slot></slot>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LayoutPanel',
  props: {
    title: String,
    rounded: {
      type: Boolean,
      default: true
    },
    transparent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  @apply shadow;
  background-color: #fff;
  border: none;
}

.panel.transparent {
  @apply shadow-none;
  background-color: transparent;
}
</style>
